import { render, staticRenderFns } from "./PermissionsOverview.vue?vue&type=template&id=4c471ab4&scoped=true"
import script from "./PermissionsOverview.vue?vue&type=script&lang=ts"
export * from "./PermissionsOverview.vue?vue&type=script&lang=ts"
import style0 from "./PermissionsOverview.vue?vue&type=style&index=0&id=4c471ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c471ab4",
  null
  
)

export default component.exports